import { ContractError, apiErrorFrom, createApiClient, shouldRetry as sharedShouldRetry } from '../../../api';

export { ApiError } from '../../../api';
export type { ApiViolation } from '../../../api';

export class ApiContractError extends ContractError {
  constructor(message: string, issues: unknown) {
    super(message, issues);
    this.name = 'ApiContractError';
  }
}

export const { request } = createApiClient({ toError: apiErrorFrom });

export const shouldRetry = sharedShouldRetry;
